import styled, { css } from "styled-components";
import { typography as Typography } from "@streeteasy/design-system";
import {
  BRAND,
  GRAY_LIGHT,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  WHITE
} from "@streeteasy/design-system/colors";
import { darken } from "polished";

import { largeScreen } from "src/shared/constants/screenSizes";

export const Dropdown = styled.div`
  background: ${WHITE};
  box-shadow: 2px 2px 4px rgb(0 0 0 / 30%);
  display: ${({ isActive }) => (isActive ? "block" : "none")};
  left: 0;
  min-height: 330px;
  padding: 40px 0;
  position: absolute;
  top: 50px;
  width: 100%;
  z-index: 1050;
`;

export const Container = styled.div`
  display: ${({ isWide }) => (isWide ? "flex" : "block")};
  justify-content: space-between;
  margin-left: auto;
  margin-right: auto;

  &:before,
  &:after {
    content: " ";
    display: table;
  }
  &:after {
    clear: both;
  }

  @media (min-width: 748px) {
    width: 748px;
  }

  @media (min-width: 980px) {
    width: 980px;
  }

  ${({ isFullWidth }) =>
    isFullWidth
      ? css`
          max-width: none;
          padding: 0 32px;
          width: 100%;
        `
      : ""}

  ${({ isWide }) =>
    isWide
      ? css`
          @media screen and (min-width: ${largeScreen + 1}px) {
            max-width: 1376px;
            padding: 0 32px;
            width: auto;
          }
        `
      : ""}

  @media screen and (max-width: ${largeScreen}px) {
    background: none;
  }
`;

export const Column = styled.div`
  display: inline-block;
  flex: 1 0 170px;
  padding-right: 20px;
  vertical-align: top;
  width: 170px;

  ${({ isLast }) =>
    isLast
      ? css`
          border-right: 1px solid ${GRAY_LIGHT};
          flex-basis: 200px;
          margin-right: 50px;
          min-height: 250px;
          padding-right: 50px;
          width: 200px;
        `
      : ""}

  ${({ isLastShort }) =>
    isLastShort
      ? css`
          border-right: 1px solid ${GRAY_LIGHT};
          flex-basis: 265px;
          margin-right: 50px;
          min-height: 250px;
          padding-right: 50px;
          width: 265px;
        `
      : ""}

  ${({ isLastLong }) =>
    isLastLong
      ? css`
          border-right: 1px solid ${GRAY_LIGHT};
          margin-right: 50px;
          min-height: 250px;
          padding-right: 50px;
          width: 438px;
        `
      : ""}

  ${({ isAds }) =>
    isAds
      ? css`
          display: inline-block;
          flex: 0 0 550px;
          padding: 0;
          width: 550px;
        `
      : ""}

  ${({ isAdsShort }) =>
    isAdsShort
      ? css`
          display: inline-block;
          flex: 0 0 300px;
          padding: 0;
          width: 300px;

          img {
            height: 250px;
            width: 300px;
          }
        `
      : ""}

  ${({ isAgentResources }) =>
    isAgentResources
      ? css`
          width: 400px;
        `
      : ""}
`;

export const Title = styled(Typography.H6)`
  color: ${TEXT_SECONDARY};
  font-size: 12px;
  font-weight: 700;
  line-height: 15px;
  margin: 0;
  text-transform: uppercase;
`;

export const List = styled.ul`
  list-style: none;
  padding: ${({ hasBottomPadding }) =>
    hasBottomPadding ? "7px 0 20px" : "7px 0"};
`;

export const ListItem = styled.li`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const ListItemLink = styled.a`
  color: ${TEXT_PRIMARY};
  cursor: pointer;
  line-height: 1.8;

  &:hover {
    color: ${BRAND};
    text-decoration: none;
  }

  &:active {
    color: ${darken(0.16, BRAND)};
    text-decoration: none;
  }
`;
